import React from 'react';
import classNames from 'classnames';
import { Site, GeojsonProperties } from 'graphql-common';
import LinkComponent, { LinkTypes } from '@lib/components/Link/Link';
import ClipboardCopy from '@lib/components/ClipboardCopy/ClipboardCopy';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import { APP_URLS } from 'constants/urls';
import styles from './SiteMapPopupContent.module.scss';

export default function SiteMapPopupContent({
  site,
  properties,
  coordinates,
}: {
  site?: Site;
  properties: GeojsonProperties;
  coordinates: number[];
}) {
  const siteName = site?.name;
  const siteCode = site?.code;
  const { address } = properties;
  const onSitePageOpen = () => {
    const to = APP_URLS.dashboard.sites.view.getDynamicPath({
      pathParts: {
        id: `${site?.id}`,
      },
    });
    window.open(to, '_blank')?.focus();
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.siteNameWrap}>
        {site?.id ? (
          <LinkComponent
            onClick={onSitePageOpen}
            type={LinkTypes.tertiaryBlack}
            className={styles.siteNameLink}
            data-test-id="site-map-popup__site-link"
          >
            <Typography variant="body" strong>
              {siteName}
            </Typography>
          </LinkComponent>
        ) : (
          <Typography variant="body" strong className={styles.siteName}>
            {siteName}
          </Typography>
        )}
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.infoItemCentered,
          entityViewStyles.infoItemWithLabelIcon,
        )}
      >
        <p className={entityViewStyles.infoItemIconLabel}>
          <MaterialIcon icon="password" symbolsOutlined />
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <Typography variant="body">{siteCode || '-'}</Typography>
        </div>
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.infoItemWithLabelIcon,
        )}
      >
        <p className={entityViewStyles.infoItemIconLabel}>
          <MaterialIcon icon="distance" symbolsOutlined />
        </p>
        <div className={entityViewStyles.infoItemContent}>
          {address ? (
            <ClipboardCopy copyText={address}>
              <Typography variant="body" className={styles.address}>
                {address}
              </Typography>
            </ClipboardCopy>
          ) : (
            <Typography variant="body">-</Typography>
          )}
        </div>
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.infoItemWithLabelIcon,
          entityViewStyles.infoItemCentered,
        )}
      >
        <p className={entityViewStyles.infoItemIconLabel}>
          <MaterialIcon icon="my_location" symbolsOutlined />
        </p>
        <div className={entityViewStyles.infoItemContent}>
          {coordinates[0] && coordinates[1] ? (
            <ClipboardCopy copyText={`${coordinates[1]} ${coordinates[0]}`}>
              <Typography variant="body">
                {coordinates[1]} {coordinates[0]}
              </Typography>
            </ClipboardCopy>
          ) : (
            <Typography variant="body">-</Typography>
          )}
        </div>
      </div>
    </div>
  );
}
